import { ReactNode } from 'react'
import { GeneralStore, GENERAL_STORE } from 'store'
import { StyleProps } from 'utilities'
import { ButtonProps } from '../Button'

export enum DialogPopupTypes {
  SUCCESS,
  INFO,
  WARNING,
  ERROR
}

export interface DialogPopupProps extends StyleProps {
  type: DialogPopupTypes
  heading?: string
  message?: string
  children?: ReactNode
  onClose?: () => void
  closeButtonLabel?: string
  buttons?: ButtonProps[]
  [GENERAL_STORE]?: GeneralStore
}

export interface DialogPopupHandlerProps {
  [GENERAL_STORE]?: GeneralStore
}
